import { IPurchaseEventPayload } from 'state/analytics/events';
import { centsToDollars } from 'utils/index';
import SessionStorage, { SessionStorageKeys } from 'utils/session-storage';
import { IUtmData } from 'utils/session-storage/types';

import { IAdobeProductItem, IAdobePurchaseEventPayload } from './adobe-events';

const PRODUCT_CATEGORIES = new Set(['L1', 'L2', 'L3', 'L4', 'L5']);

export const transformPurchaseData = (
  payload: IPurchaseEventPayload
): IAdobePurchaseEventPayload => {
  const utmData: IUtmData | null = SessionStorage.getItem(SessionStorageKeys.UTM_DATA);

  const adobeEventPayload: IAdobePurchaseEventPayload = {
    commerce: {
      order: {
        priceTotal: centsToDollars(payload.serverOrder.cart.subTotalCents),
        currency: payload.attrs.currencyCode,
        purchaseID: payload.serverOrder?.rbiOrderId,
      },
    },

    productListItems: payload.cartEntries.map(entry => {
      const product: IAdobeProductItem = {
        SKU: entry._id,
        quantity: entry.quantity,
        priceTotal: entry.price,
        name: entry.name,
      };

      const productCategories = entry.productHierarchy
        ? Object.keys(entry.productHierarchy)
            .filter(category => {
              return PRODUCT_CATEGORIES.has(category);
            })
            .map(category => {
              return { categoryName: entry?.productHierarchy?.[category] };
            })
        : null;

      if (productCategories) {
        product.productCategories = productCategories;
      }
      return product;
    }),
  };

  if (utmData && Object.values(utmData).some(value => value !== null)) {
    adobeEventPayload.marketing = {
      campaignGroup: utmData?.utm_medium ?? null,
      campaignName: utmData?.utm_source ?? null,
      trackingCode: utmData?.utm_campaign ?? null,
      _timhortons: {
        trackingTerm: utmData?.utm_term ?? null,
        trackingContent: utmData?.utm_content ?? null,
      },
    };
  }
  return adobeEventPayload;
};
